import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { NavbarTooltipProps } from './types';
import { useTranslation } from 'react-i18next';

export const NavbarTooltip = ({ name, children }: NavbarTooltipProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'navigation' });

  return <AppTooltip context={<p>{t(name)}</p>}>{children}</AppTooltip>;
};
